"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteableLabel = DeleteableLabel;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Label = styled_components_1.default.div `
  display: flex;
  align-items: center;
  margin-right: 5px;
  background: linear-gradient(
    to bottom right,
    white 10%,
    rgba(255, 228, 128, 255)
  );
  border: 1px solid #333;
  border-radius: 10px;
  font-size: 12px;
  color: #000;
`;
const TextContainer = styled_components_1.default.div `
  padding: 5px 6px;
`;
const DeleteContainer = styled_components_1.default.div `
  padding-right: 5px;
  color: #808080;
  font-size: 10px;

  &:hover {
    cursor: pointer;
    color: #f00;
  }
`;
function DeleteableLabel({ onDelete, text }) {
    return (React.createElement(Label, null,
        React.createElement(TextContainer, null, text),
        React.createElement(DeleteContainer, { onClick: onDelete }, "X")));
}
//# sourceMappingURL=deletable-label.js.map